import styles from './Login.module.scss';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { signInWithPhoneNumber } from 'firebase/auth';

import { auth } from '../../components/App/FirebaseSetup';
import { useUserContext } from '../../context/UserContext';
import { Input } from '../Shared/Input/Input';
import { GreenButton } from '../Shared/GreenButton/GreenButton';

export const Login = () => {
    const navigate = useNavigate();
    const { user, isLoading } = useContext(AuthContext);
    const [phone, setPhone] = useState('');
    const { updateUser } = useUserContext();

    const [signInProcess, setSignInProcess] = useState<boolean>(false);
    const onChangePhone = (e: React.SyntheticEvent<EventTarget>) => {
        setPhone((e.target as HTMLInputElement).value ?? '');
    };

    const logIn = async () => {
        console.log('user', user);
        console.log('Start signIn with number: ', phone);

        setSignInProcess(true);

        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const appVerifier = window.recaptchaVerifier;
            const userPhone = `+${phone}`;

            const confirmation = await signInWithPhoneNumber(auth, userPhone, appVerifier);
            console.log('result confirmation: ', confirmation);

            updateUser({
                confirmation,
                userPhone,
            });
            setSignInProcess(false);
            navigate('/login/verify');
        } catch (err) {
            setSignInProcess(false);
            console.log('error signIn:', err);
        }
    };

    useEffect(() => {
        if (!isLoading && user) {
            navigate('/');
        }
    }, [user, isLoading]);

    return (
        <div className={styles.container}>
            <div className={styles.title}>Log in to Admin panel</div>
            <div className={styles.subTitle}>We’ll send you the code</div>
            <div className={styles.loginBox}>
                <div className={styles.inputBox}>
                    <Input type="tel" onChange={onChangePhone} />
                </div>
                <GreenButton disabled={signInProcess} onClick={logIn}>
                    Get SMS code
                </GreenButton>
            </div>
        </div>
    );
};
